@if (alert_type_1) {
  <div id="close">
    <a (click)="dialogRef.close()">
      <mat-icon class="icon-pattern">close</mat-icon>
    </a>
  </div>

  <h4 mat-dialog-title [style.background-color]="color" class="title">{{status}}</h4>

  <p class="message2 primary-text">{{mensagem}}</p>
}

@if (alert_type_2) {
  <mat-checkbox checked="true" disabled="true"></mat-checkbox>
  <br><br>
  <p class="message primary-text">{{mensagem}}</p>
}